import React, { FC, useEffect, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import './attach_documents_form.scss';

import { PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Form, Modal, Row, Spin, Upload, message } from 'antd';
import { UploadChangeParam, UploadFile } from 'antd/es/upload';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useNavigate } from 'react-router';
import { useFormContext } from '../../Context/DeclarationContext';
import { EmailDriver } from '../../Interfaces/Declaration.Interface';
import { saveDeclaration, uploadFiles } from '../../Services/declarations';
import RutTools from '../../helpers/format-rut';
import { FILE_UPLOAD_GENERAL_ERROR, FILE_UPLOAD_LARGE_ERROR, getBase64 } from '../../utils/generals';
import AttachNewAditionalDocument from '../AttachNewAditionalDocument';
import FormAdjunto from '../Form_adjunto';
import { HOME_ROUTE } from '../Router/constant';
const ACTIVATE_RECAPTCHA = process.env.REACT_APP_ACTIVATE_RECAPTCHA === 'true' ? true : false;
interface Adjunto {
  structureAdjunto: any;
  setStructureAdjunt?: any;
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}
const AttachDocumentsForm: FC<Adjunto> = ({ structureAdjunto, showModal, setShowModal }) => {
  const navigate = useNavigate();
  const reRef = React.createRef();
  // const [showModal, setShowModal] = useState(initialShowModal);
  const { state, dispatch } = useFormContext();

  const initialDocumentDOCA = state.state_document?.filter((item: any) => item.documentType.includes('DOCA') && item.isActive === true) || [];

  const [documentDOCA, setDocumentDOCA] = useState<any[]>(initialDocumentDOCA);
  const [indexDOCA, setIndexDOCA] = useState<number>(initialDocumentDOCA.length > 0 ? initialDocumentDOCA.length + 1 : 1);

  const [fileListFDVP, setFileListFDVP] = useState<any[]>(
    // TRAER DEL STATE.state_document LOS ARCHIVOS QUE SE HAYAN SUBIDO CON EL TIPO DE DOCUMENTO FDVP1, FDVP2, FDVP3, FDVP4, FDVP5, FDVP6 y el isActive sea true
    state.state_document
      ?.filter(
        (item: any) =>
          (item.documentType.includes('FDVP1') && item.isActive) ||
          (item.documentType.includes('FDVP2') && item.isActive) ||
          (item.documentType.includes('FDVP3') && item.isActive) ||
          (item.documentType.includes('FDVP4') && item.isActive) ||
          (item.documentType.includes('FDVP5') && item.isActive) ||
          (item.documentType.includes('FDVP6') && item.isActive)
      )
      .map((item) => {
        return {
          uid: item.filename,
          name: item.filename,
          status: 'done',
          url: item.url,
        };
      }) || []
  );

  const [fileListFDV3, setFileListFDV3] = useState<any[]>(
    state.state_document
      ?.filter(
        (item: any) =>
          (item.documentType.includes('FDV31') && item.isActive) ||
          (item.documentType.includes('FDV32') && item.isActive) ||
          (item.documentType.includes('FDV33') && item.isActive) ||
          (item.documentType.includes('FDV34') && item.isActive) ||
          (item.documentType.includes('FDV35') && item.isActive) ||
          (item.documentType.includes('FDV36') && item.isActive)
      )
      .map((item) => {
        return {
          uid: item.filename,
          name: item.filename,
          status: 'done',
          url: item.url,
        };
      }) || []
  );

  //el fdv31 tiene que estar en la parte de docs requeridos, los demas deben seguir iguales

  const [indexFDVP, setIndexFDVP] = useState<number>(fileListFDVP.length ? fileListFDVP.length + 1 : 1);
  const [indexFDV3, setIndexFDV3] = useState<number>(fileListFDV3.length ? fileListFDV3.length + 1 : 1);

  const [previewImage, setPreviewImage] = useState({
    previewOpen: false,
    title: '',
    url: '',
    mediaType: '',
  });

  const [loadingFileVehiculoPropio, setLoadingFileVehiculoPropio] = useState(false);
  const [loadingFileVehiculoTerceros, setLoadingFileVehiculoTerceros] = useState(false);
  const [modalNewAditionalDocument, setModalNewAditionalDocument] = useState({
    openModal: false,
    titleModal: 'Adjuntar documento',
  });

  const finalDocuList: any[] = [];

  const restartIndexDOCA = (index: string) => {
    let document = state.state_document || [];
    const item = state.state_document?.findIndex((item: any) => item.documentType === index);

    if (item && item !== -1) {
      document[item].isActive = false;
      dispatch({
        type: 'UPDATE_STATE_DOCUMENT',
        payload: [...document],
      });
      if (indexDOCA > 1) {
        setIndexDOCA(indexDOCA - 1);
      }
    }
  };

  const aumentarIndexDOCA = () => {
    setIndexDOCA(indexDOCA + 1);
  };

  const closeModalAditionalDocument = () => {
    setModalNewAditionalDocument({ ...modalNewAditionalDocument, openModal: false });
  };

  const modalSucces = (id: any, mandatoryDocsFilled: boolean) => {
    Modal.success({
      width: 580,
      title: (
        <h3>
          {mandatoryDocsFilled
            ? `Proceso de declaración de siniestro ha finalizado correctamente, su número de seguimiento es: ${id}`
            : `Se ha generado el siguiente
            número de Seguimiento: N° ${id}`}
        </h3>
      ),
      centered: true,
      content: (
        <div>
          {mandatoryDocsFilled ? (
            <div>
              Hemos recibido su formulario de declaración de manera correcta, recibirá un correo desde el cual podrá hacer seguimiento al estado de su
              siniestro.
            </div>
          ) : (
            <div>
              El formulario de declaración de siniestro ha sido enviado con éxito, para finalizar el proceso de declaración de siniestro debe adjuntar
              los documentos requeridos en un plazo no mayor a 48 horas, podrá adjuntarlo (los) ingresando desde el link que recibirá a través del
              correo electrónico de confirmación.
            </div>
          )}
        </div>
      ),
      footer: (
        <div className="btn_footer_modal">
          <Button
            type="primary"
            shape="round"
            style={{
              fontWeight: 700,
            }}
            className="btn_primary_modal"
            onClick={() => {
              Modal.destroyAll();
              navigate(HOME_ROUTE);
            }}
          >
            Aceptar
          </Button>
        </div>
      ),
    });
  };

  const modalSuccesTimeOut = () => {
    Modal.success({
      width: 580,
      title: <h3>Se ha generado siniestro:</h3>,
      centered: true,
      content: (
        <div>
          <div>
            El formulario de declaración de siniestro ha sido enviado con éxito, para finalizar el proceso de declaración de siniestro debe adjuntar
            los documentos requeridos en un plazo no mayor a 48 horas, podrá adjuntarlo (los) ingresando desde el link que recibirá a través del
            correo electrónico de confirmación.
          </div>
        </div>
      ),
      footer: (
        <div className="btn_footer_modal">
          <Button
            type="primary"
            shape="round"
            style={{
              fontWeight: 700,
            }}
            className="btn_primary_modal"
            onClick={() => {
              Modal.destroyAll();
              navigate(HOME_ROUTE);
            }}
          >
            Aceptar
          </Button>
        </div>
      ),
    });
  };

  useEffect(() => {
    console.log('Step 5', state);
    setDocumentDOCA(state.state_document?.filter((item: any) => item.documentType.includes('DOCA')) || []);
  }, [state]);

  const beforeUploadValidations = (info: UploadChangeParam<UploadFile<any>>): boolean => {
    const isJpgOrPng =
      info.file.type === 'image/jpg' ||
      info.file.type === 'image/png' ||
      info.file.type === 'image/jpeg' ||
      info.file.type === 'video/mp4' ||
      info.file.type === 'video/quicktime' ||
      info.file.type === 'video/x-msvideo' ||
      info.file.type === 'video/x-ms-wmv' ||
      info.file.type === 'video/x-flv' ||
      info.file.type === 'video/mpeg' ||
      info.file.type === 'video/webm';

    if (!isJpgOrPng) {
      message.error('Solo puede subir archivos JPG, PNG, JPEG, MP4, QUICKTIME, X-MSVIDEO, X-MS-WMV, X-FLV, MPEG, WEBM');
    }
    const size = info.file.size ?? 0;
    const isLt2M = size / 1024 / 1024 <= 10;
    if (!isLt2M) {
      message.error(FILE_UPLOAD_LARGE_ERROR);
    }
    return isJpgOrPng && isLt2M;
  };

  const onUploadFotosDanosVehiculoPropio = async (info: UploadChangeParam<UploadFile<any>>) => {
    console.log('onUploadFotosDanosVehiculoPropio file info: ', info);

    if (info.file.status === 'removed') {
      const { name } = info.file;

      let documents = state?.state_document || [];
      const indexToDrop = documents.findIndex((doc) => doc.documentType?.includes('FDVP') && doc.filename === name);

      let fileListFDVPTemp = [...fileListFDVP];
      const indexToDropView = fileListFDVPTemp.findIndex((file: any) => file?.name === name);

      if (indexToDrop !== -1) {
        documents[indexToDrop].filename = null;
        documents[indexToDrop].url = '';
        documents[indexToDrop].isActive = false;
        dispatch({
          type: 'UPDATE_STATE_DOCUMENT',
          payload: [...documents],
        });

        if (indexToDropView !== -1) {
          fileListFDVPTemp.splice(indexToDropView, 1);
          setFileListFDVP([...fileListFDVPTemp]);
        }
        message.success('Documento eliminado correctamente');
      }
    }

    if (info.file !== undefined && info.file.status !== 'removed') {
      const beforeValidations = beforeUploadValidations(info);
      if (beforeValidations) {
        info.file.name = `${state.vehiclePatente?.deviceId}_${RutTools.formatWithoutDots(state?.declarant?.customerIdentityNumber || ('' as string))}`;

        try {
          setLoadingFileVehiculoPropio(true);
          const response = await uploadFiles(
            info.file.originFileObj,
            `FDVP${indexFDVP}`,
            `${state.vehiclePatente?.deviceId}_${RutTools.formatWithoutDots(state?.declarant?.customerIdentityNumber || ('' as string))}`
          );
          info.file.name = response.data[0].filename;
          let document = state?.state_document || [];
          info.file.status = 'done';
          const index = document.findIndex((doc) => doc.documentType === `FDVP${indexFDVP}`);

          if (index !== -1) {
            document[index].filename = response.data[0].filename;
            document[index].url = response.data[0].url;
            document[index].isActive = true;
            // document[index].mediaType = '';

            setFileListFDVP([
              ...fileListFDVP,
              {
                name: response.data[0].filename,
                url: response.data[0].url,
                isActive: true,
                mediaType: info.file.type,
              },
            ]);
          }

          dispatch({
            type: 'UPDATE_STATE_DOCUMENT',
            payload: [...document],
          });
          message.success('Documento subido correctamente');
          setIndexFDVP(indexFDVP + 1);
        } catch (error) {
          const g = error as any;
          if (g?.status === 413) {
            message.error(FILE_UPLOAD_LARGE_ERROR);
          } else {
            message.error(FILE_UPLOAD_GENERAL_ERROR);
          }
        } finally {
          setLoadingFileVehiculoPropio(false);
        }
      }
    }
  };

  const onUploadFotosDanosVehiculoPropioOrTerceros = async (info: UploadChangeParam<UploadFile<any>>) => {
    console.log('onUploadFotosDanosVehiculoPropioOrTerceros file info: ', info);

    if (info.file.status === 'removed') {
      const { name } = info.file;
      let documents = state?.state_document || [];
      const indexToDrop = documents.findIndex((doc) => doc.documentType?.includes('FDV3') && doc.filename === name);

      let fileListFDVPTemp = [...fileListFDV3];
      const indexToDropView = fileListFDVPTemp.findIndex((file: any) => file?.name === name);

      if (indexToDrop !== -1) {
        documents[indexToDrop].filename = null;
        documents[indexToDrop].url = '';
        documents[indexToDrop].isActive = false;
        dispatch({
          type: 'UPDATE_STATE_DOCUMENT',
          payload: [...documents],
        });

        if (indexToDropView !== -1) {
          fileListFDVPTemp.splice(indexToDropView, 1);
          setFileListFDV3([...fileListFDVPTemp]);
        }
        message.success('Documento eliminado correctamente');
      }
    }

    if (info.file !== undefined && info.file.status !== 'removed') {
      const beforeValidations = beforeUploadValidations(info);
      if (beforeValidations) {
        try {
          setLoadingFileVehiculoTerceros(true);
          info.file.name = `${state.vehiclePatente?.deviceId}_${RutTools.formatWithoutDots(state?.declarant?.customerIdentityNumber || ('' as string))}`;
          const response = await uploadFiles(
            info.file.originFileObj,
            `FDV3${indexFDV3}`,
            `${state.vehiclePatente?.deviceId}_${RutTools.formatWithoutDots(state.declarant?.customerIdentityNumber || ('' as string))}`
          );
          let document = state?.state_document || [];
          info.file.status = 'done';

          const index = document.findIndex((doc) => doc.documentType === `FDV3${indexFDV3}`);
          if (index !== -1) {
            document[index].filename = response.data[0].filename;
            document[index].url = response.data[0].url;
            document[index].status = 'done';
            document[index].isActive = true;

            setFileListFDV3([
              ...fileListFDV3,
              {
                name: response.data[0].filename,
                url: response.data[0].url,
                isActive: true,
                mediaType: info.file.type,
              },
            ]);
          }

          dispatch({
            type: 'UPDATE_STATE_DOCUMENT',
            payload: [...document],
          });
          message.success('Documento subido correctamente');
          setIndexFDV3(indexFDV3 + 1);
        } catch (error) {
          const g = error as any;
          if (g?.status === 413) {
            message.error(FILE_UPLOAD_LARGE_ERROR);
          } else {
            message.error(FILE_UPLOAD_GENERAL_ERROR);
          }
        } finally {
          setLoadingFileVehiculoTerceros(false);
        }
      }
    }
  };

  const handlePreviewFile = async (file: UploadFile) => {
    // @ts-ignore
    const { mediaType } = file;
    if (!file.url && !file.preview && file.originFileObj) {
      file.preview = await getBase64(file.originFileObj);
    }

    setPreviewImage({
      previewOpen: true,
      url: file.url || (file.preview as string),
      title: file.name,
      mediaType,
    });
  };

  const printAdjuntarFotosVideos = (tipo: 'propios' | 'terceros') => {
    return (
      <Row
        gutter={[16, 16]}
        style={{
          marginTop: '20px',
        }}
      >
        <Col span={24}>
          {tipo === 'propios' ? (
            <div className="title">Adjuntar fotografías y/o videos del vehículo propio</div>
          ) : (
            <div className="title">Adjuntar fotografías y/o videos del vehículo o bien del tercero.</div>
          )}
          <div className="subtitle">
            En esta sección debe ingresar los documentos relacionados con su siniestro, con un peso máximo de 10MB.
            <ul>
              {tipo === 'propios' ? (
                <li>Fotografías con los daños al vehículo asegurado considerando la placa patente.</li>
              ) : (
                <li>Fotografías con los daños a terceros considerando la placa patente.</li>
              )}
            </ul>
          </div>
        </Col>
      </Row>
    );
  };

  return (
    <>
      <div className="attach_document">
        <div className="title">6. Adjuntar documentos</div>
        <div className="subtitle">
          En esta sección debe ingresar los documentos relacionados con su siniestro, con un peso máximo de 10MB{' '}
          <strong className="text_time">(JPG, PNG, JPEG, PDF)</strong>
        </div>
        <div className="subtitle-2">
          Puede adjuntar otros documentos que sean relevantes. En caso de no contar con todos los documentos en esta etapa, puede finalizar la
          declaración y <strong className="text_time">en un plazo máximo de 48 horas</strong> podrá adjuntarlos ingresando desde el link que recibirá
          en su correo electrónico.
        </div>

        {state.loading && <Spin fullscreen />}
        <Form>
          <Row
            gutter={[16, 16]}
            justify={'center'}
            style={{
              maxWidth: '98%',
            }}
          >
            <Col xs={10} xl={8}>
              <label className="classLabel">Requerimiento</label>
            </Col>
            <Col xs={10} xl={8}>
              <label className="classLabel">Nombre</label>
            </Col>
            <Col xs={0} xl={3}>
              <label className="classLabel">Adjuntar/firmar</label>
            </Col>

            <Col
              xs={0}
              xl={3}
              style={{
                textAlign: 'center',
              }}
            >
              <label className="classLabel">Visualizar</label>
            </Col>
            <Col span={2}>
              <label className="classLabel"></label>
            </Col>
          </Row>
          {// traer del estado los documentos que se tengan isActive true
          state.state_document?.map((item: any, index: number) => {
            if (item.isActive && item.obligatorio && item.documentType !== 'FDF' && item.documentType !== 'ALC') {
              finalDocuList.push(item);
              // console.log('item.documentType: ', item.documentType);
              return (
                <FormAdjunto
                  key={index}
                  obligatorio={item.obligatorio}
                  nombre={item.nombreTitulo}
                  nombreAdjunto={item.filename}
                  adjuntar={true}
                  visualizar={false}
                  componentFirma={item.documentType}
                  documentType={item.documentType}
                  deleteItemIndexDOCA={restartIndexDOCA}
                />
              );
            }

            if (item.documentType === 'ALC' && state.hasAPoliceReport === true && state.policeReport?.alcoholTestConducted === true) {
              return (
                <FormAdjunto
                  key={index}
                  obligatorio={item.obligatorio}
                  nombre={item.nombreTitulo}
                  nombreAdjunto={item.filename}
                  adjuntar={true}
                  visualizar={false}
                  componentFirma={item.documentType}
                  documentType={item.documentType}
                  deleteItemIndexDOCA={restartIndexDOCA}
                />
              );
            }

            if (
              (state.state_form.nameOptionDescriptionAccidemt === 'DAÑO' ||
                state.state_form.nameOptionDescriptionAccidemt === 'SOLO DAÑOS A TERCEROS') &&
              state.thirdPartyInvolved?.propertyInvolved &&
              item.documentType === 'CRQ'
            ) {
              finalDocuList.push(item);
              return (
                <FormAdjunto
                  key={index}
                  obligatorio={item.obligatorio}
                  nombre={item.nombreTitulo}
                  nombreAdjunto={item.filename}
                  adjuntar={true}
                  visualizar={false}
                  componentFirma={item.documentType}
                  documentType={item.documentType}
                  deleteItemIndexDOCA={restartIndexDOCA}
                />
              );
            }

            if (
              (state.state_form.nameClaimCauseId === 'Robo habido (vehículo encontrado)' ||
                state.state_form.nameClaimCauseId === 'Robo no habido (vehículo no encontrado)') &&
              item.documentType === 'CROB'
            ) {
              finalDocuList.push(item);
              return (
                <FormAdjunto
                  key={index}
                  obligatorio={item.obligatorio}
                  nombre={item.nombreTitulo}
                  nombreAdjunto={item.filename}
                  adjuntar={true}
                  visualizar={false}
                  componentFirma={item.documentType}
                  documentType={item.documentType}
                  deleteItemIndexDOCA={restartIndexDOCA}
                />
              );
            }

            if (item.documentType === 'PTP') {
              if (
                state?.hasAPoliceReport === true ||
                (state?.state_form?.nameOptionDescriptionAccidemt &&
                  state.state_form.nameOptionDescriptionAccidemt.toLowerCase().includes('robo') &&
                  !state?.hasAPoliceReport) ||
                (state?.state_form?.nameClaimCauseId &&
                  state.state_form.nameClaimCauseId.toLowerCase().includes('actos maliciosos') &&
                  !state?.hasAPoliceReport) ||
                state?.policeReport?.InjuriesOcurred === true
              ) {
                finalDocuList.push(item);
                return (
                  <FormAdjunto
                    key={index}
                    obligatorio={true}
                    nombre="Parte policial / Denuncia"
                    nombreAdjunto={item.filename}
                    adjuntar={true}
                    visualizar={false}
                    componentFirma={item.documentType}
                    documentType={item.documentType}
                    deleteItemIndexDOCA={restartIndexDOCA}
                  />
                );
              } else {
                const fdf = state.state_document?.find((item) => item.documentType === 'FDF');
                if (fdf) {
                  finalDocuList.push(fdf);
                  return (
                    <FormAdjunto
                      key={index}
                      obligatorio={true}
                      nombre={fdf.nombreTitulo ?? ''}
                      nombreAdjunto={fdf.filename ?? undefined}
                      adjuntar={true}
                      visualizar={false}
                      componentFirma={'FDF'}
                      documentType={'FDF'}
                      deleteItemIndexDOCA={restartIndexDOCA}
                    />
                  );
                }
              }
            }
          })}

          {documentDOCA
            .filter((item) => item.isActive === true)
            .map((item: any, index: number) => (
              <FormAdjunto
                key={index}
                obligatorio={item.obligatorio}
                nombre={item.nombreTitulo}
                nombreAdjunto={item.filename}
                adjuntar={true}
                visualizar={false}
                componentFirma={item.documentType}
                documentType={item.documentType}
                deleteItemIndexDOCA={restartIndexDOCA}
              />
            ))}
          {indexDOCA < 6 && (
            <Row
              gutter={[16, 16]}
              style={{
                marginTop: '20px',
              }}
            >
              <Col span={24}>
                <Button
                  className="btn_add"
                  onClick={() =>
                    setModalNewAditionalDocument({
                      ...modalNewAditionalDocument,
                      openModal: true,
                    })
                  }
                >
                  <PlusOutlined /> Agregar nuevo documento adicional
                </Button>
              </Col>
            </Row>
          )}
          <Divider />
          {state.state_form.nameOptionDescriptionAccidemt !== 'SOLO DAÑOS A TERCEROS' &&
          state.state_form.nameClaimCauseId &&
          !state.state_form.nameClaimCauseId.toLowerCase().includes('no encontrado') ? (
            <>
              {printAdjuntarFotosVideos('propios')}
              <Row gutter={[16, 16]} className="classRowAdjunto">
                <Col span={24}>
                  <label>Foto daños del vehículo propios</label>{' '}
                  <small>Archivos JPG, PNG, JPEG, MP4, QUICKTIME, X-MSVIDEO, X-MS-WMV, X-FLV, MPEG, WEBM - Tamaño máximo 10MB. </small>
                  <small> (Obligatorio mínimo 1)</small>
                </Col>

                <Col span={24}>
                  <Spin spinning={loadingFileVehiculoPropio} size="small">
                    <Upload
                      name="avatar"
                      customRequest={() => {}}
                      listType="picture"
                      defaultFileList={fileListFDVP.length > 0 ? [...fileListFDVP] : []}
                      fileList={fileListFDVP.length > 0 ? [...fileListFDVP] : []}
                      maxCount={6}
                      onChange={onUploadFotosDanosVehiculoPropio}
                      onPreview={handlePreviewFile}
                    >
                      <div className="upload_file">
                        <UploadOutlined /> Subir Imagen / Video
                      </div>
                    </Upload>
                  </Spin>
                </Col>
              </Row>
            </>
          ) : null}
          {state.state_form.nameOptionDescriptionAccidemt === 'SOLO DAÑOS A TERCEROS' ||
          (state.state_form.nameOptionDescriptionAccidemt !== 'ROBO' &&
            state.thirdPartyInvolved?.propertyInvolved &&
            state.thirdPartyInvolved.thirdPartyInformationAvailable) ? (
            <>
              {printAdjuntarFotosVideos('terceros')}
              <Row gutter={[16, 16]} className="classRowAdjunto">
                <Col span={24}>
                  <label>Foto daños del vehículo o bien del tercero</label>
                  <small>Archivos JPG, PNG, JPEG, MP4, QUICKTIME, X-MSVIDEO, X-MS-WMV, X-FLV, MPEG, WEBM - Tamaño máximo 10MB. </small>
                  <small> (Obligatorio mínimo 1)</small>
                </Col>

                <Col span={24}>
                  <Spin spinning={loadingFileVehiculoTerceros} size="small">
                    <Upload
                      name="avatar"
                      customRequest={() => {}}
                      listType="picture"
                      defaultFileList={fileListFDV3.length ? [...fileListFDV3] : undefined}
                      fileList={fileListFDV3.length > 0 ? [...fileListFDV3] : []}
                      maxCount={6}
                      onChange={onUploadFotosDanosVehiculoPropioOrTerceros}
                      onPreview={handlePreviewFile}
                    >
                      <div className="upload_file">
                        <UploadOutlined /> Subir Imagen / Video
                      </div>
                    </Upload>
                  </Spin>
                </Col>
              </Row>
            </>
          ) : null}
        </Form>
        {/* <Divider
          style={{
            marginTop: '90px',
          }}
        /> */}
        {/* <Row gutter={[16, 16]}>
          <Col span={24}>
            <Button className="btnGrabar" onClick={() => setShowModal(!showModal)}>
              Grabar y finalizar
            </Button>
          </Col>
        </Row> */}
        <Modal
          open={showModal}
          centered
          footer={
            <div className="btn_footer_modal">
              <Button className="btn_white" onClick={() => setShowModal(!showModal)}>
                Volver a revisar
              </Button>

              <Button
                type="primary"
                shape="round"
                className="btn_primary_modal"
                onClick={async () => {
                  console.log('finalDocuList: ', finalDocuList);
                  dispatch({
                    type: 'SET_LOADING',
                    payload: true,
                  });
                  setShowModal(!showModal);
                  // modalSucces()

                  console.log('token', reRef.current);

                  console.log('state', state);
                  // (reRef.current as ReCAPTCHA).reset();

                  const customEmail = state?.driver?.emails ? (state?.driver?.emails as EmailDriver[]) : [];

                  // limpiador de campos
                  // Convertir el objeto Day.js a un objeto Date de JavaScript
                  dayjs.extend(utc);
                  dayjs.extend(timezone);
                  const claimDateInLocalTime = dayjs(state.claimDate)
                    .tz('America/Santiago', true) // Ajusta la fecha a la zona horaria especificada
                    .format('YYYY-MM-DD');
                  const citationDate = dayjs(state.policeReport?.judicialCourt?.citation_date)
                    .tz('America/Santiago', true) // Ajusta la fecha a la zona horaria especificada
                    .format('YYYY-MM-DD');
                  const licenseValidityStartDate = dayjs(state.driver?.licenseValidityStartDate)
                    .tz('America/Santiago', true) // Ajusta la fecha a la zona horaria especificada
                    .format('YYYY-MM-DD');
                  const licenseValidityEndDate = dayjs(state.driver?.licenseValidityEndDate)
                    .tz('America/Santiago', true) // Ajusta la fecha a la zona horaria especificada
                    .format('YYYY-MM-DD');

                  let data = {
                    shortId: state.shortId,
                    claimDate: claimDateInLocalTime,
                    claimTime: state.claimTime,
                    claimCauseId: state.claimCauseId,
                    hasAPoliceReport: state.hasAPoliceReport,
                    description: state.description,
                    vehicleDamageComponents: state.vehicleDamageComponents,
                    additionalNotes: state.additionalNotes,
                    signages: [state.signages],

                    address: state.address,
                    declarant: {
                      customerIdentifierType: state.declarant?.identifierTypeClient,
                      identifierType: state.declarant?.identifierType,
                      customerName: state.declarant?.customerName,
                      customerIdentityNumber: state.declarant?.customerIdentityNumber,
                      declarantIdentityNumber: state.declarant?.declarantIdentityNumber,
                      declarantFullName: state.declarant?.declarantFullName,
                      phoneNumber: `${state.declarant?.phoneNumber.phone_code} ${state.declarant?.phoneNumber?.stringValue}`,
                      emails: state.declarant?.emails,
                    },
                    driver: {
                      ...state.driver,
                      licenseValidityStartDate,
                      licenseValidityEndDate,
                      emails: customEmail.map((item) => item.email),
                      phoneNumber: `${state.driver?.phoneNumber.phone_code} ${state.driver?.phoneNumber?.stringValue}`,
                    },
                    //TODO: agregar el chasisNumber y engineNumber desde el state al payload
                    contractSupervisorEmail: state.vehiclePatente?.contractSupervisorEmail,
                    vehicle: {
                      deviceId: state.vehiclePatente?.deviceId,
                      year: state.vehiclePatente?.year,
                      model: state.vehiclePatente?.model,
                      brand: state.vehiclePatente?.brand,
                      chasisNumber: state.vehiclePatente?.chasisNumber,
                      engineNumber: state.vehiclePatente?.engineNumber,
                    },
                    policeReport: {
                      reportDate: state.policeReport?.declarationDate ?? undefined,
                      policeStationReference: state.policeReport?.policeStationReference,
                      declarationDate: state.policeReport?.declarationDate,
                      policeReportNumber: state.policeReport?.policeReportNumber,
                      hasACourtDate: state.policeReport?.hasACourtDate,
                      alcoholTestConducted: state.policeReport?.alcoholTestConducted,
                      InjuriesOcurred: state.policeReport?.InjuriesOcurred,
                      hasARetainedLicense: state.policeReport?.licenseRetention,
                      judicialCourt: {
                        name: state.policeReport?.judicialCourt?.name,
                        citationDate,
                      },
                    },
                    thirdPartyInvolved: {
                      propertyInvolved: state.thirdPartyInvolved?.propertyInvolved,
                      peopleInjured: state.thirdPartyInvolved?.peopleInjured,
                      thirdPartyInformationAvailable: state.thirdPartyInvolved?.thirdPartyInformationAvailable,
                      thirdPartyInvolvedInformation: state.thirdPartyInvolved?.thirdPartyInvolvedInformation?.map((item: any) => {
                        // eliminar el campo indicador de cada item del array
                        let { indicador, ...rest } = item;
                        return rest;
                      }),
                    },
                    documents: state?.state_document,
                    reCaptcha: '',
                  };

                  //cutomizer Phone numbers on thirdPartyInvolved
                  const dataCopy = Object.assign({}, data);
                  const newThirdPartyInvolvedInformation = data.thirdPartyInvolved?.thirdPartyInvolvedInformation?.map((item) => {
                    if (item.damageType === 'VEHICLE') {
                      return {
                        ...item,
                        thirdPartyVehicleInformation: {
                          ...item.thirdPartyVehicleInformation,
                          phoneNumber: `${item.thirdPartyVehicleInformation.phoneNumber.phone_code ? item.thirdPartyVehicleInformation.phoneNumber.phone_code : '+56'} ${item.thirdPartyVehicleInformation?.phoneNumber?.stringValue ? item.thirdPartyVehicleInformation?.phoneNumber?.stringValue : ''}`,
                        },
                      };
                    }

                    return {
                      ...item,
                      thirdPartyPersonOrPropertyInformation: {
                        ...item.thirdPartyPersonOrPropertyInformation,
                        phoneContact: `${item.thirdPartyPersonOrPropertyInformation.phoneContact.phone_code ? item.thirdPartyPersonOrPropertyInformation.phoneContact.phone_code : '+56'} ${item.thirdPartyPersonOrPropertyInformation?.phoneContact?.stringValue ? item.thirdPartyPersonOrPropertyInformation?.phoneContact?.stringValue : ''}`,
                      },
                    };
                  });

                  dataCopy.thirdPartyInvolved.thirdPartyInvolvedInformation = newThirdPartyInvolvedInformation;

                  if (ACTIVATE_RECAPTCHA) {
                    const current = reRef.current as ReCAPTCHA;
                    const token = await current.executeAsync();
                    data.reCaptcha = token as string;
                    current.reset();
                  }

                  const obligatorios = finalDocuList.filter((item) => item.obligatorio);
                  const obligatoriosLlenos = finalDocuList.filter((item) => item.obligatorio && item.url.length > 0);

                  try {
                    const response = await saveDeclaration(data);
                    console.log('RESPUESTA', response);
                    const { id } = response.data;

                    if (id) modalSucces(id, obligatorios.length === obligatoriosLlenos.length);

                    dispatch({
                      type: 'CLEAN_DECLARATION_FORM_STATE',
                      payload: null,
                    });
                  } catch (err) {
                    console.log(err, 'err');
                    if (err.status === 504) {
                      modalSuccesTimeOut();
                    } else {
                      message.error('Ha ocurrido un error al declarar el siniestro');
                    }
                  } finally {
                    dispatch({
                      type: 'SET_LOADING',
                      payload: false,
                    });
                  }
                }}
              >
                Enviar formulario
              </Button>
            </div>
          }
        >
          <h3>Si la información esta correcta seleccione “Enviar Formulario”</h3>
          <p>
            ¡Atención! Asegúrese que toda la información este correcta, una vez que ha enviado el Formulario de Declaración de Siniestro, no se podrán
            modificar los datos.
          </p>
        </Modal>

        {ACTIVATE_RECAPTCHA && <ReCAPTCHA sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY || ('' as string)} ref={reRef as any} size="invisible" />}
      </div>
      <Modal
        open={previewImage.previewOpen}
        title={previewImage.title}
        footer={null}
        onCancel={() => setPreviewImage({ ...previewImage, previewOpen: false })}
        width={1000}
      >
        {previewImage.mediaType.includes('image') && <img alt="preview" style={{ width: '100%' }} src={previewImage.url} />}
        {previewImage.mediaType.includes('video') && (
          <video style={{ width: '100%' }} src={previewImage.url} autoPlay loop controls>
            <p>Su navegador no soporta vídeos HTML5.</p>
          </video>
        )}
      </Modal>
      <AttachNewAditionalDocument
        openModal={modalNewAditionalDocument.openModal}
        titleModal={modalNewAditionalDocument.titleModal}
        closeModal={closeModalAditionalDocument}
        indexDOCA={indexDOCA}
        updateIndexDOCA={aumentarIndexDOCA}
      ></AttachNewAditionalDocument>
    </>
  );
};

export default AttachDocumentsForm;
